/**
 * Generated by orval 🍺
 * Do not edit manually.
 * ViridisChem API
 * API documentation for ViridisChem API
 */

/**
 * Backend-owned react-i18next resource namespace.
 */
export type TranslationNamespace =
    (typeof TranslationNamespace)[keyof typeof TranslationNamespace];

export const TranslationNamespace = {
    /** General user-interface labels and messages. */
    UI: "UI",
    /** Reaction and route-planning user-interface resources. */
    REACTIONS: "REACTIONS",
    /** Frontend GHS display labels. This namespace is not the authoritative legal SDS catalog. */
    GHS: "GHS",
    /** Property and workflow tooltip text. */
    TOOLTIPS: "TOOLTIPS",
    /** SDS Builder user-interface resources. */
    SDS: "SDS",
    /** Temporary merged compatibility namespace containing all five named namespaces. */
    TRANSLATION: "TRANSLATION",
} as const;
